module.exports = __webpack_public_path__ + "static/media/file-type-file.54242955.svg";